import React, {useState, useEffect} from 'react';
import {useLinkProps} from '@react-navigation/native';
import {View, TouchableOpacity, Platform, StyleSheet} from 'react-native';

import FontelloIcon from './FontelloIcon';
import AppText from './AppText';
import EStyleSheet from 'react-native-extended-stylesheet';
import {getThemeTransitionStyle} from '../views/MessageFlow/theme';

const FontelloLink = ({to, action, children, active, icon, label, darkMode = false, ...rest}) => {
	const {onPress, ...props} = useLinkProps({to, action});
	const [isHovered, setIsHovered] = useState(false);
	const [, setShowPopupTimeout] = useState(null);
	const [popupShown, setPopupShown] = useState(false);

	useEffect(() => {
		if (isHovered) {
			setShowPopupTimeout(() => setTimeout(() => {
				setPopupShown(true);
			}, 0));
		} else {
			setShowPopupTimeout((showPopupTimeOut) => {
				clearTimeout(showPopupTimeOut);
			});
			setPopupShown(false);
		}
	}, [isHovered]);

	if (Platform.OS === 'web') {
		return (
			<View
				onClick={onPress}
				onMouseEnter={() => setIsHovered(true)}
				onMouseLeave={() => setIsHovered(false)}
				style={[
					styles.iconWrapper,
					getThemeTransitionStyle('background-color,color,border-color'),
					(active ? styles.iconWrapperActive : styles.iconWrapperInactive),
					(darkMode ? (active ? styles.iconWrapperActiveDark : styles.iconWrapperInactiveDark) : null),
				]}
				{...props}
				{...rest}
			>
				{
					popupShown ?
						<View style={[styles.popupLabelContainer, getThemeTransitionStyle('background-color,border-color,color'), darkMode ? styles.popupLabelContainerDark : null]}>
							<AppText style={[styles.popupLabel, darkMode ? styles.popupLabelDark : null]}>
								{label}
							</AppText>
						</View>
						: null
				}
				<FontelloIcon
					name={icon}
					style={[
						{
							fontSize: 20,
							...getThemeTransitionStyle('color'),
						},
						((active || isHovered) ? styles.iconActive : styles.iconInactive),
						(darkMode ? ((active || isHovered) ? styles.iconActiveDark : styles.iconInactiveDark) : null),
					]}
				/>
				<AppText style={[
					styles.mobileLabel,
					(active ?  styles.mobileLabelActive : null),
					darkMode ? {color: '#FFF'} : null,
				]}>{label}</AppText>
			</View>
		);
	}

	return (
		<TouchableOpacity
			onPress={onPress} {...props} {...rest}
			style={[
				styles.iconWrapper,
				getThemeTransitionStyle('background-color,color,border-color'),
				(active ? styles.iconWrapperActive : styles.iconWrapperInactive),
				(darkMode ? (active ? styles.iconWrapperActiveDark : styles.iconWrapperInactiveDark) : null),
			]}
		>
			<FontelloIcon
				name={icon}
				style={[
					{fontSize: 20},
					((active) ? styles.iconActive : styles.iconInactive),
					(darkMode ? (active ? styles.iconActiveDark : styles.iconInactiveDark) : null),
				]}
			/>
			<AppText style={[styles.mobileLabel, (active ?  styles.mobileLabelActive : null)]}>{label}</AppText>
		</TouchableOpacity>
	);

};

export default FontelloLink;

const styles = EStyleSheet.create({
	iconWrapper: {
		width: 55,
		height: 55,
		borderRadius: 55 / 2,
		alignItems: 'center',
		justifyContent: 'center',
	},
	iconWrapperActive: {
		backgroundColor: '#F8FAFD'
	},
	iconWrapperInactive: {
		backgroundColor: 'transparent'
	},
	iconWrapperActiveDark: {
		backgroundColor: 'transparent'
	},
	iconWrapperInactiveDark: {
		backgroundColor: 'transparent'
	},
	iconActive: {
		color: '#0065DB',
	},
	iconInactive: {
		color: '#D9D9D9',
	},
	iconActiveDark: {
		color: '#3CA6F5',
	},
	iconInactiveDark: {
		color: '#FFFFFF',
	},
	popupLabelContainer: {
		position: 'absolute',
		left: '90%',
		padding: 8,
		borderWidth: 1,
		borderColor: '#E2E9F4',
		borderRadius: 8,
		backgroundColor: '#FFFFFF',
		shadowColor: '#000',
		shadowOffset: {
			width: 0,
			height: 3,
		},
		shadowOpacity: 0.1,
		shadowRadius: 9.11,
	},
	popupLabel: {
		color: '#467AFF',
		fontSize: 12,
		whiteSpace: 'nowrap',
	},
	popupLabelContainerDark: {
		backgroundColor: '#0E161A',
		borderColor: '#343A43',
	},
	popupLabelDark: {
		color: '#FFFFFF'
	},
	mobileLabel: {
		display: 'none'
	},
	'@media (max-width: 630)': {
		iconWrapper: {
			flexDirection: 'row',
			width: '100%',
			paddingLeft: 30,
			justifyContent:'flex-start',
			borderRadius: 0,
			borderBottomWidth: 1,
			borderColor: '#E2E9F4'
		},
		popupLabelContainer: {
			display: 'none'
		},
		iconWrapperActive: {
			backgroundColor: '#0065DB'
		},
		iconActive: {
			color: '#FFF'
		},
		iconInactive: {
			color: '#0065DB'
		},
		mobileLabel: {
			display: 'flex',
			paddingLeft: 30,
		},
		mobileLabelActive: {
			color: '#FFF'
		}
	}
});
